import type { ILocalizedText, Lang } from '@platform/core/types';

/** Підпис з метаданих мовою інтерфейсу; за відсутності перекладу — англійський (Issue 025). */
export function localized(text: ILocalizedText | null | undefined, lang: Lang): string {
  if (!text) return '';
  return (lang === 'uk' ? text.uk ?? text.en : text.en ?? text.uk) ?? '';
}
